const sequenceDataSelector = state => state.sequenceData;
export default sequenceDataSelector;
